import { render, staticRenderFns } from "./landingTab.vue?vue&type=template&id=358cb2cd&scoped=true&"
import script from "./landingTab.vue?vue&type=script&lang=js&"
export * from "./landingTab.vue?vue&type=script&lang=js&"
import style0 from "./landingTab.vue?vue&type=style&index=0&id=358cb2cd&scoped=true&lang=scss&"
import style1 from "./landingTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358cb2cd",
  null
  
)

export default component.exports